import {
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Space,
  Spin,
  message,
  theme,
  Typography,
  Divider,
  Tabs,
  Button,
  Avatar,
  Empty,
  Radio,
  Card,
  Row,
  Select
} from 'antd'
import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { useDispatch, useSelector } from 'react-redux'
import { createBooking, sendOTP, updateBooking } from '../../utils/utils'
import { generateOTP, handleError } from '../../../lib/utils'
import { readConfig } from '../../../Admin/config/utils/utils'
import bookingsReducer from '../../utils/booking-reducer'
import coreReducer from '../../../../core/utils/reducer'
import { executeBooking, registerBooking } from '../../utils/bpm-utils'
import { findAgiliteUser } from '../../../Auth/utils/utils'
import MobileNav from './MobileNav'
import CustomRow from '../../../reusable-components/CustomRow'
import BookingSummary from './widgets/AppointmentSummary'
import { deviceDetect } from 'react-device-detect'
import CustomButton from '../../../reusable-components/CustomButton'
import PatientSectionHeader from '../../../Patient/Reusable Components/PatientSectionHeader'
import { handleVerifyAvailability } from '../../utils/lib'
import ServicesEnums from '../../../Admin/services/utils/enums'
import { readClinics } from '../../../Admin/clinics/utils/utils'
import { updateAllBookingsState } from '../../../lib/booking-utils'
import { sendWhatsAppMessage, sendWhatsAppOTPMessage } from '../../../WhatsApp/utils'
import EmbeddedPayment from '../../../PeachPayments/components/EmbeddedPayment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCreditCard,
  faCoins,
  faHeartPulse,
  faMoneyBill,
  faCheckCircle,
  faHome,
  faVideoCamera,
  faCalendarCheck
} from '@fortawesome/free-solid-svg-icons'
import { hexToRGBA } from '../../../lib/utils'

const { Option } = Select

const BookingFinalize = ({
  prevStep,
  bookingDetails,
  setBookingDetails,
  nextStep,
  isHomeVisit,
  isVirtualVisit,
  patient,
  isReceptionBooking,
  setReceptionLoadIndicator,
  onAfterSuccessfulBooking,
  targetBooking,
  onAfterFailedBooking,
  isScheduledBooking
}) => {
  const dispatch = useDispatch()
  const { token } = theme.useToken()

  const [terms, setTerms] = useState()
  const [termsAgreedTo, setTermsAgreedTo] = useState(isReceptionBooking || isScheduledBooking)
  const [additionalInfo, setAdditionalInfo] = useState()
  const [clientForm] = Form.useForm()
  const [displayTerms, setDisplayTerms] = useState()
  const [loading, setLoading] = useState()
  const [showValidationErrors, setShowValidationErrors] = useState(false)
  const authState = useSelector((state) => state.auth)
  const servicesData = useSelector((state) => state.services?.data || [])
  const virtualServicesData = useSelector((state) => state.virtualServices?.data || [])
  const bookingsData = useSelector((state) => state.bookings?.data || [])
  const dashboardData = useSelector((state) => state.bookings?.dashboardData || [])

  const serviceInfo =
    servicesData.find((item) => item._id === bookingDetails.service) ||
    virtualServicesData.find((item) => item._id === bookingDetails.service)
  const [mainPatient, setMainPatient] = useState(patient)
  const [isDependant, setIsDependant] = useState(false)
  const [verifying, setVerifying] = useState(false)
  const [formValues, setFormValues] = useState({})

  // Payment States
  const [renderPayment, setRenderPayment] = useState(false)

  // Helper function to check if the service is flexi or priority
  const isFlexiOrPriorityConsult = () => {
    // For flexi/priority consultations, we don't assign a medical professional
    // Also check service name as a fallback
    const serviceName = serviceInfo?.name?.toLowerCase() || ''
    const isUnassigned = !bookingDetails.medicalProf || bookingDetails.medicalProf === null
    const hasFlexiName = serviceName.includes('flexi') || serviceName.includes('priority')

    return isUnassigned || hasFlexiName
  }

  // Helper function to get payment method icons
  const getPaymentIcon = (method) => {
    switch (method.toLowerCase()) {
      case 'card':
        return faCreditCard
      case 'cash':
        return faCoins
      case 'medical aid':
        return faHeartPulse
      default:
        return faMoneyBill
    }
  }

  // Check if form is complete for button enabling
  const isFormComplete = () => {
    const hasPaymentMethod = isVirtualVisit || formValues.paymentMethod
    const hasTermsAgreed = isReceptionBooking || isScheduledBooking || termsAgreedTo

    return hasPaymentMethod && hasTermsAgreed
  }

  useEffect(() => {
    if (mainPatient) {
      if (!mainPatient.phoneNumber && !mainPatient.email) {
        handleFindMainPatient()
      }
    }

    // eslint-disable-next-line
  }, [])

  const handleFindMainPatient = async () => {
    let tmpMainPatient = null
    try {
      tmpMainPatient = await findAgiliteUser({ dependants: { $in: [mainPatient._id] } })

      if (tmpMainPatient) {
        setIsDependant(true)
        setMainPatient(tmpMainPatient)
      }
    } catch (e) {
      message.error(handleError(e, true))
    }
  }

  useEffect(() => {
    handleSetTerms()
    // Initialize form values
    const initialValues = clientForm.getFieldsValue()
    setFormValues(initialValues)
    // eslint-disable-next-line
  }, [])

  // Update form completion check when terms agreement changes
  useEffect(() => {
    // Force re-render when terms agreement changes
    setFormValues((prev) => ({ ...prev }))
  }, [termsAgreedTo])

  const handleSetTerms = () => {
    const tmpTerms = authState.terms.find((i) => {
      if (i.linkedPractice) {
        return i.linkedPractice === bookingDetails.clinicTermsRef
      } else {
        return null
      }
    })
    if (tmpTerms) {
      setTerms(tmpTerms)
    } else {
      setTerms(authState.terms[0])
    }
  }

  const validateBooking = async () => {
    console.log('🔄 validateBooking called - Flow Analysis:', {
      isVirtualVisit,
      isScheduledBooking,
      isReceptionBooking,
      bookingDetailsExists: !!bookingDetails,
      userRole: authState?.agiliteUser?.extraData?.role?.type,
      hasNextStep: !!nextStep
    })

    try {
      // For scheduled bookings, update the existing booking
      if (isScheduledBooking) {
        console.log('🟠 Scheduled booking path - calling handleUpdateBooking')
        handleUpdateBooking()
      } else {
        // For new bookings, create the booking first, then navigate to confirmation screen
        console.log('🟢 New booking path - creating booking then navigating to confirmation')

        // Create the booking
        await confirmBooking()

        // After successful booking creation, navigate to confirmation view
        console.log('✅ Booking created successfully - navigating to confirmation screen')
        if (nextStep) {
          nextStep() // This should navigate to BookingConfirmation (AppointmentConfirmationView)
        } else {
          console.error('❌ nextStep function not available')
          // Fallback to dashboard navigation if nextStep not available
          dispatch(
            coreReducer.actions.changeTab({
              activeKey: 'home'
            })
          )
        }
      }
    } catch (error) {
      console.error('❌ Error in validateBooking:', error)
      message.error('Failed to create booking. Please try again.')
    }
  }

  const confirmBooking = async (callpayGatewayReference) => {
    console.log('confirmBooking - Props received:', {
      isVirtualVisit,
      isHomeVisit,
      isReceptionBooking,
      isScheduledBooking,
      'typeof isVirtualVisit': typeof isVirtualVisit,
      'bookingDetails.service': bookingDetails.service
    })

    let tmpCheckinData = {}
    let otp = null
    let tmpBookings = []
    let tmpDashBoardBookings = []
    let processRecord = null
    let processUser = null
    console.log('🔍 FinalizeAppointment - bookingDetails received:', bookingDetails)
    console.log('🔍 FinalizeAppointment - bookingDetails.dischem:', bookingDetails.dischem)
    console.log('🔍 FinalizeAppointment - All bookingDetails keys:', Object.keys(bookingDetails))
    console.log('🔍 FinalizeAppointment - bookingDetails has dischem property:', 'dischem' in bookingDetails)

    let payload = JSON.parse(JSON.stringify(bookingDetails))

    console.log('🔍 FinalizeAppointment - payload after copy:', payload)
    console.log('🔍 FinalizeAppointment - payload.dischem after copy:', payload.dischem)

    let clinicData = null
    let bpmKey = null
    let tmpResult = null

    if (setReceptionLoadIndicator) {
      setReceptionLoadIndicator(false)
    }
    setLoading(true)

    try {
      // For flexi/priority consultations, we may not have a specific clinic
      if (isVirtualVisit && isFlexiOrPriorityConsult() && !bookingDetails.clinicRef) {
        // Use a default virtual clinic or the first available one
        const virtualClinics = await readClinics({}, isVirtualVisit)
        clinicData = virtualClinics[0]
      } else {
        tmpResult = await readClinics({ _id: bookingDetails.clinicRef }, isVirtualVisit)
        clinicData = tmpResult[0]
      }

      // BPM Key
      bpmKey = 'patient_journey'

      // For flexi and priority consultations, don't assign a medical professional (unclaimed)
      if (isVirtualVisit && isFlexiOrPriorityConsult()) {
        // Don't set medicalProfRef for flexi/priority consultations - they should be unclaimed
        payload.medicalProfRef = null
        payload.medicalProf = null
        // Set booking date to today for immediate availability
        payload.bookingDate = new Date().toISOString()
        payload.startTime = null
        payload.endTime = null
        // Ensure clinic reference is set for virtual consultations
        if (!payload.clinicRef) {
          payload.clinicRef = clinicData._id
          payload.clinicTermsRef = clinicData._id
        }
      } else {
        payload.medicalProfRef = payload.medicalProf._id
      }

      // Ensure patient information is included in the payload
      payload.patientRecord = patient || authState.agiliteUser
      payload.patientName = patient
        ? `${patient.firstName} ${patient.lastName}`
        : `${authState.agiliteUser.firstName} ${authState.agiliteUser.lastName}`
      payload.patientRef = patient ? patient._id : authState.agiliteUser._id

      payload = { ...payload, ...additionalInfo, status: { ...bookingDetails.status, checkedIn: true } }

      // Include appointment reason as chiefComplaint in the payload
      if (bookingDetails.appointmentReason) {
        payload.chiefComplaint = bookingDetails.appointmentReason
      }

      otp = generateOTP(6)
      payload.otp = otp
      setBookingDetails({ ...bookingDetails, ...payload })

      if (isVirtualVisit) {
        payload.isVirtualVisit = true
      }

      // BPM
      if (patient) {
        processUser = `${authState.agiliteUser.firstName} ${authState.agiliteUser.lastName}`
        payload.userRef = patient._id
        setBookingDetails({ ...bookingDetails, ...payload })
      } else {
        processUser = `${authState.agiliteUser.firstName} ${authState.agiliteUser.lastName}`
      }

      processRecord = await registerBooking(bpmKey, processUser)

      if (isHomeVisit && !isVirtualVisit) {
        // If it is a Home Visit and not a Virtual Consultation, we need to go from new booking to nurse examination (skipping the checkin step)
        processRecord = await executeBooking(
          bpmKey,
          processRecord.recordId,
          'submit',
          processUser,
          processRecord.key,
          'screening' // This is the nextStepKey used by BPM, here we are going from patient check in to nurse examination
        )
      } else if (isVirtualVisit) {
        console.log('BPM: Virtual Visit Path - isVirtualVisit =', isVirtualVisit)
        // If Virtual Consultation, we need to go from new booking to doctor diagnosis (skipping the checkin and nurse examination steps)
        processRecord = await executeBooking(
          bpmKey,
          processRecord.recordId,
          'submit',
          processUser,
          processRecord.key,
          'consultation' // This is the nextStepKey used by BPM, here we are going from patient checkin to doctor diagnosis (skipping the nurse examination step)
        )
      } else {
        console.log('BMP: In-Person/Scheduled Path - isVirtualVisit =', isVirtualVisit, 'isHomeVisit =', isHomeVisit)
        // If it is a Scheduled Booking, we need to go from new booking to patient check in
        processRecord = await executeBooking(
          bpmKey,
          processRecord.recordId,
          'submit',
          processUser,
          processRecord.key,
          'check_in'
        )
      }

      console.log('🔍 Creating booking with payload:', payload)
      console.log('🔍 Payload dischem data:', payload.dischem)
      console.log('🔍 Full payload keys:', Object.keys(payload))
      console.log('🔍 bookingDetails object:', bookingDetails)
      console.log('🔍 bookingDetails dischem:', bookingDetails.dischem)

      let newBooking = await createBooking({
        ...payload,
        processRef: processRecord.recordId,
        status: clinicData?.bpmConfig?.find((e) => e.key === processRecord.key)?.key,
        callpayGatewayReference
      })

      console.log('🔍 Created booking:', newBooking)
      console.log('🔍 Created booking dischem data:', newBooking.dischem)

      if (isReceptionBooking) {
        // Not awaiting this as it is not critical
        sendWhatsAppMessage(mainPatient.phoneNumber, 'appointment_confirmation', [
          { type: 'text', text: `${mainPatient.firstName} ${mainPatient.lastName}` },
          {
            type: 'text',
            text: bookingDetails.medicalProf
              ? `${bookingDetails.medicalProf.firstName} ${bookingDetails.medicalProf.lastName}`
              : 'Available doctor will be assigned'
          },
          { type: 'text', text: `${dayjs(bookingDetails.bookingDate).format('MMM D, YYYY')}` },
          { type: 'text', text: bookingDetails.startTime || 'Flexible timing - doctor will call you' },
          { type: 'text', text: `${clinicData.name}` },
          { type: 'text', text: `${clinicData.phoneNumber}` }
        ])

        console.log('OTP Branch 1 - Before check:', {
          isVirtualVisit,
          'typeof isVirtualVisit': typeof isVirtualVisit,
          '!isVirtualVisit': !isVirtualVisit,
          'bookingDetails.medicalProf exists': !!bookingDetails.medicalProf
        })

        if (!isVirtualVisit) {
          // For in-person bookings, medicalProf should always be assigned
          if (bookingDetails.medicalProf) {
            console.log('About to call sendOTP with:', {
              otp,
              'bookingDetails merged': { ...bookingDetails, ...mainPatient },
              patient,
              isDependant,
              'clinicData.name': clinicData.name
            })
            try {
              await sendOTP(otp, { ...bookingDetails, ...mainPatient }, patient, isDependant, clinicData.name)
              console.log('✅ sendOTP Branch 1 completed successfully')
            } catch (error) {
              console.error('❌ sendOTP Branch 1 failed with error:', error)
              console.error('❌ Branch 1 Error details:', {
                message: error.message,
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data
              })
              // Re-throw to maintain existing error handling
              throw error
            }
            try {
              await sendWhatsAppOTPMessage(mainPatient.phoneNumber, 'otp_authentication', otp)
              console.log('✅ sendWhatsAppOTPMessage Branch 1 completed successfully')
            } catch (error) {
              console.error('❌ sendWhatsAppOTPMessage Branch 1 failed with error:', error)
              // Don't re-throw - WhatsApp failure shouldn't block the booking
            }
          } else {
            console.error('Medical professional not assigned for in-person booking:', bookingDetails)
            message.error('Unable to send OTP: Medical professional not assigned')
          }
        }
      } else {
        // Not awaiting this as it is not critical
        sendWhatsAppMessage(authState.agiliteUser.phoneNumber, 'appointment_confirmation', [
          { type: 'text', text: `${authState.agiliteUser.firstName} ${authState.agiliteUser.lastName}` },
          {
            type: 'text',
            text: bookingDetails.medicalProf
              ? `${bookingDetails.medicalProf.firstName} ${bookingDetails.medicalProf.lastName}`
              : 'Available doctor will be assigned'
          },
          { type: 'text', text: `${dayjs(bookingDetails.bookingDate).format('MMM D, YYYY')}` },
          { type: 'text', text: bookingDetails.startTime || 'Flexible timing - doctor will call you' },
          { type: 'text', text: `${clinicData.name}` },
          { type: 'text', text: `${clinicData.phoneNumber}` }
        ])

        console.log('OTP Branch 2 - Before check:', {
          isVirtualVisit,
          'typeof isVirtualVisit': typeof isVirtualVisit,
          '!isVirtualVisit': !isVirtualVisit,
          'bookingDetails.medicalProf exists': !!bookingDetails.medicalProf,
          'bookingDetails.medicalProf': bookingDetails.medicalProf
        })

        if (!isVirtualVisit) {
          // For in-person bookings, medicalProf should always be assigned
          if (bookingDetails.medicalProf) {
            const mergedData = { ...bookingDetails, ...authState.agiliteUser }
            console.log('About to call sendOTP with (Branch 2):', {
              otp,
              mergedData: JSON.stringify(mergedData, null, 2),
              patient: JSON.stringify(patient, null, 2),
              isDependant,
              'clinicData.name': clinicData.name
            })
            try {
              await sendOTP(otp, { ...bookingDetails, ...authState.agiliteUser }, patient, isDependant, clinicData.name)
              console.log('✅ sendOTP completed successfully')
            } catch (error) {
              console.error('❌ sendOTP failed with error:', error)
              console.error('❌ Error details:', {
                message: error.message,
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data
              })
              // Re-throw to maintain existing error handling
              throw error
            }

            try {
              await sendWhatsAppOTPMessage(authState.agiliteUser.phoneNumber, 'otp_authentication', otp)
              console.log('✅ sendWhatsAppOTPMessage completed successfully')
            } catch (error) {
              console.error('❌ sendWhatsAppOTPMessage failed with error:', error)
              console.error('❌ WhatsApp Error details:', {
                message: error.message,
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data
              })
              // Don't re-throw - WhatsApp failure shouldn't block the booking
            }
          } else {
            console.error('Medical professional not assigned for in-person booking:', bookingDetails)
            message.error('Unable to send OTP: Medical professional not assigned')
          }
        }
      }

      // Update Bookings State
      if (authState.agiliteUser.extraData.role.type === 'patient') {
        // Set temporary booking states to whatever it was previously plus the new booking
        tmpBookings = [...bookingsData, newBooking]
        tmpDashBoardBookings = [...dashboardData, newBooking]
        // Sort Bookings by date
        tmpBookings.sort((a, b) => {
          // Handle null startTime for flexi bookings
          const getBookingDateTime = (booking) => {
            if (!booking.startTime) {
              // For flexi bookings without specific time, just use the booking date
              return new Date(booking.bookingDate)
            }
            // For scheduled bookings with specific time
            return new Date(
              dayjs(booking.bookingDate)
                .set('hours', booking.startTime.slice(0, 2))
                .set('minutes', booking.startTime.slice(-2))
            )
          }

          return getBookingDateTime(b) - getBookingDateTime(a)
        })
        // update the main bookings state for patient this will be in two plces:
        dispatch(bookingsReducer.actions.setRecords(tmpBookings))
        dispatch(bookingsReducer.actions.setDashboardRecords(tmpDashBoardBookings))
      } else {
        tmpDashBoardBookings = [...dashboardData, newBooking]
        dispatch(bookingsReducer.actions.setDashboardRecords(tmpDashBoardBookings))
      }

      message.success('Booking Successful')

      // Clear session storage after successful booking
      sessionStorage.removeItem('isCurrentBookingPriority')

      console.log('🎯 Booking created successfully:', {
        isReceptionBooking,
        hasOnAfterSuccessfulBooking: !!onAfterSuccessfulBooking,
        userRole: authState.agiliteUser.extraData.role.type,
        note: 'Navigation will be handled by validateBooking or confirmation view'
      })

      // For reception bookings, call the success callback
      if (isReceptionBooking && onAfterSuccessfulBooking) {
        console.log('📋 Reception booking - calling onAfterSuccessfulBooking')
        onAfterSuccessfulBooking()
      }

      // For patient bookings, navigation will be handled by validateBooking() or confirmation view
      console.log('✅ confirmBooking completed - returning control to caller')
    } catch (e) {
      console.error('🚨 Error in confirmBooking:', e)
      console.error('🚨 Error details:', {
        message: e.message,
        stack: e.stack,
        name: e.name
      })
      handleError(e)
      message.error('Unable to make booking')
    }

    if (setReceptionLoadIndicator) {
      setReceptionLoadIndicator(false)
    }
    setLoading(false)
  }

  const handleUpdateBooking = async () => {
    let updatedBookingRecord = null
    setLoading(true)
    const payload = {}

    // Build payload
    payload.service = bookingDetails.service
    payload.bookingDate = bookingDetails.bookingDate
    payload.medicalProfRef = bookingDetails.medicalProf._id
    payload.startTime = bookingDetails.startTime
    payload.endTime = bookingDetails.endTime
    payload.scheduledBy = authState.agiliteUser._id
    payload.isVirtualVisit = true

    try {
      updatedBookingRecord = await updateBooking(payload, { _id: targetBooking })
    } catch (error) {
      message.error(handleError(error))
    }
    setLoading(false)
    updateAllBookingsState(updatedBookingRecord)
    onAfterSuccessfulBooking({
      bookingDate: updatedBookingRecord.bookingDate,
      endTime: updatedBookingRecord.endTime,
      medicalProfRef: updatedBookingRecord.medicalProfRef,
      service: updatedBookingRecord.service,
      startTime: updatedBookingRecord.startTime
    })
  }

  const handleData = () => {
    const values = clientForm.getFieldsValue()
    setFormValues(values)
    setAdditionalInfo(values)
  }

  return (
    <>
      {renderPayment ? (
        <EmbeddedPayment
          amount={serviceInfo?.rate || 0}
          patientRecord={authState.agiliteUser}
          paymentType={bookingDetails.paymentMethod}
          isAuthorization={true}
          callback={(merchantReference) => {
            confirmBooking(merchantReference)
            setRenderPayment(false)
          }}
        />
      ) : (
        <>
          {terms && !isReceptionBooking ? (
            <Modal
              title={
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    fontSize: '18px',
                    fontWeight: 600,
                    color: '#262626'
                  }}
                >
                  📋 Terms & Conditions
                </div>
              }
              open={displayTerms}
              onOk={() => {
                setDisplayTerms(false)
              }}
              onCancel={() => {
                setDisplayTerms(false)
              }}
              width={700}
              style={{ top: 40 }}
              okText='I Understand'
              okButtonProps={{
                style: {
                  height: '40px',
                  borderRadius: '8px',
                  fontWeight: 600
                }
              }}
              cancelButtonProps={{
                style: {
                  height: '40px',
                  borderRadius: '8px'
                }
              }}
            >
              <div
                style={{
                  padding: '20px 0',
                  borderTop: '1px solid #f0f0f0',
                  marginTop: '16px'
                }}
              >
                <div
                  style={{
                    backgroundColor: '#f6ffed',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    border: '1px solid #b7eb8f',
                    marginBottom: '20px'
                  }}
                >
                  <small
                    style={{
                      color: '#52c41a',
                      fontWeight: 500,
                      fontSize: '13px'
                    }}
                  >
                    Last updated: <strong>{dayjs(terms.dateModified).format('DD MMMM YYYY')}</strong>
                  </small>
                </div>
                <div
                  style={{
                    lineHeight: '1.6',
                    fontSize: '14px',
                    color: '#262626',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    padding: '0 4px'
                  }}
                  dangerouslySetInnerHTML={{ __html: terms.data }}
                />
              </div>
            </Modal>
          ) : undefined}
          <Form
            onFinishFailed={(errorInfo) => {
              console.log('❌ Form submission failed:', errorInfo)
              message.error('Please ensure all required information has been provided.')
            }}
            onFinish={() => {
              console.log('✅ Form submitted successfully - calling validateBooking')
              validateBooking()
            }}
            layout='vertical'
            form={clientForm}
            onFieldsChange={() => {
              handleData(clientForm.getFieldsValue())
            }}
          >
            <div
              style={{
                maxWidth: '1200px',
                margin: '0 auto',
                padding: '24px',
                minHeight: '100vh',
                background: '#f8fafc'
              }}
            >
              {/* Header Section */}
              <PatientSectionHeader
                icon={isHomeVisit ? faHome : isVirtualVisit ? faVideoCamera : faCalendarCheck}
                title='Finalize Your Appointment'
                subtitle='Review your booking details and complete the final steps'
                variant='gradient'
                color='16, 178, 225'
              />

              {/* Back Button - Outside the cards */}
              {!isReceptionBooking && (
                <div style={{ marginBottom: '20px' }}>
                  <CustomButton
                    text='← Back to Previous Step'
                    type='primary'
                    loading={loading || verifying}
                    disabled={loading || verifying}
                    onClick={() => {
                      if (!loading && !verifying) {
                        prevStep()
                      }
                    }}
                    style={{
                      height: '40px',
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: 500,
                      display: 'flex !important',
                      alignItems: 'center !important',
                      justifyContent: 'center !important',
                      backgroundColor: '#1890ff',
                      borderColor: '#1890ff',
                      color: 'white',
                      lineHeight: '1 !important',
                      padding: '0 16px !important',
                      textAlign: 'center !important',
                      verticalAlign: 'middle !important'
                    }}
                  />
                </div>
              )}

              <CustomRow style={{ gap: '16px' }}>
                {isReceptionBooking ? undefined : (
                  <Col span={24}>
                    <div
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: '16px',
                        padding: '32px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                        border: '1px solid rgba(16, 178, 225, 0.1)',
                        marginBottom: '16px'
                      }}
                    >
                      <div style={{ marginBottom: '24px' }}>
                        <h3
                          style={{
                            margin: '0 0 8px 0',
                            fontSize: '20px',
                            fontWeight: 600,
                            color: '#262626',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          📋 Booking Summary
                        </h3>
                        <p
                          style={{
                            margin: 0,
                            fontSize: '14px',
                            color: '#8c8c8c',
                            lineHeight: '1.5'
                          }}
                        >
                          Please review your appointment details below
                        </p>
                      </div>

                      <BookingSummary
                        isScheduledBooking={isScheduledBooking}
                        booking={bookingDetails}
                        patient={patient}
                        serviceInfo={serviceInfo}
                        isVirtualVisit={isVirtualVisit}
                      />
                    </div>
                  </Col>
                )}

                {!isVirtualVisit ? (
                  <Col span={24}>
                    <div
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: '16px',
                        padding: '32px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                        border: '1px solid rgba(16, 178, 225, 0.1)',
                        marginBottom: '16px'
                      }}
                    >
                      <div style={{ marginBottom: '20px' }}>
                        <h3
                          style={{
                            margin: '0 0 8px 0',
                            fontSize: '20px',
                            fontWeight: 600,
                            color: '#262626',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}
                        >
                          💳 Payment Method
                        </h3>
                        <p
                          style={{
                            margin: 0,
                            fontSize: '14px',
                            color: '#8c8c8c',
                            lineHeight: '1.5'
                          }}
                        >
                          Select your preferred payment method for this consultation
                        </p>
                      </div>
                      <Form.Item
                        style={{ margin: 0 }}
                        rules={[{ required: true, message: 'Please select a payment method' }]}
                        name='paymentMethod'
                      >
                        <Radio.Group style={{ width: '100%' }}>
                          <Row gutter={[16, 16]}>
                            {bookingDetails.paymentMethods.map((option) => (
                              <Col key={option} xs={24} sm={12} md={8}>
                                <div style={{ position: 'relative' }}>
                                  <Radio
                                    value={option}
                                    style={{
                                      position: 'absolute',
                                      top: '16px',
                                      right: '16px',
                                      transform: 'scale(1.2)',
                                      zIndex: 2,
                                      pointerEvents: 'none'
                                    }}
                                  />
                                  <Card
                                    size='small'
                                    style={{
                                      borderRadius: '12px',
                                      transition: 'all 0.3s ease',
                                      cursor: 'pointer',
                                      height: '100px',
                                      border: `2px solid ${hexToRGBA(token.colorBorder, 0.2)}`,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      position: 'relative'
                                    }}
                                    className='payment-method-card'
                                    bodyStyle={{
                                      padding: '16px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      height: '100%',
                                      width: '100%'
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault()
                                      // Find the hidden radio and trigger its click
                                      const radio = e.currentTarget.parentElement.querySelector('input[type="radio"]')
                                      if (radio) {
                                        radio.click()
                                      }
                                    }}
                                  >
                                    {/* Center content - Icon and Text */}
                                    <div
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: '8px',
                                        flex: 1
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={getPaymentIcon(option)}
                                        style={{
                                          fontSize: '28px',
                                          color: token.colorPrimary
                                        }}
                                      />
                                      <Typography.Text
                                        style={{
                                          fontSize: '14px',
                                          fontWeight: '500',
                                          textAlign: 'center'
                                        }}
                                      >
                                        {option}
                                      </Typography.Text>
                                    </div>
                                  </Card>
                                </div>
                              </Col>
                            ))}
                          </Row>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  </Col>
                ) : undefined}

                <Col span={24}>
                  {!isVirtualVisit && !isReceptionBooking ? (
                    <div
                      style={{
                        marginBottom: '20px',
                        padding: '16px',
                        backgroundColor: '#fff7e6',
                        borderRadius: '8px',
                        border: '1px solid #ffd591'
                      }}
                    >
                      <h4
                        style={{
                          margin: '0 0 8px 0',
                          fontSize: '14px',
                          fontWeight: 600,
                          color: '#d46b08',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px'
                        }}
                      >
                        ⚠️ Important Notice
                      </h4>
                      <p
                        style={{
                          margin: 0,
                          fontSize: '13px',
                          color: '#ad6800',
                          lineHeight: '1.4'
                        }}
                      >
                        If you do not <strong>cancel</strong> your appointment within <strong>3 hours</strong> of
                        booking time, you will be liable for a <strong>R500</strong> nurse and doctor's fee.
                      </p>
                    </div>
                  ) : undefined}

                  {isReceptionBooking || isScheduledBooking ? undefined : (
                    <div
                      style={{
                        marginBottom: '20px',
                        textAlign: 'center'
                      }}
                    >
                      <div
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: '12px 16px',
                          backgroundColor: '#f6ffed',
                          borderRadius: '8px',
                          border: '1px solid #b7eb8f'
                        }}
                      >
                        <Checkbox
                          onChange={(e) => {
                            setTermsAgreedTo(e.target.checked)
                          }}
                          style={{ margin: 0 }}
                        />
                        <span style={{ fontSize: '14px', color: '#262626' }}>
                          I agree to the{' '}
                          <span
                            style={{
                              color: '#1890ff',
                              cursor: 'pointer',
                              textDecoration: 'underline',
                              fontWeight: 500
                            }}
                            onClick={() => {
                              setDisplayTerms(true)
                            }}
                          >
                            Terms & Conditions
                          </span>
                        </span>
                      </div>
                    </div>
                  )}

                  {deviceDetect().isMobile ? undefined : (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
                      <CustomButton
                        text='Confirm Appointment'
                        type='primary'
                        loading={loading || verifying}
                        disabled={!isFormComplete() || loading || verifying}
                        style={{
                          width: '280px',
                          height: '48px',
                          borderRadius: '8px',
                          fontSize: '16px',
                          fontWeight: 600,
                          boxShadow: isFormComplete() ? '0 2px 4px rgba(24, 144, 255, 0.2)' : 'none',
                          border: 'none',
                          opacity: isFormComplete() ? 1 : 0.6,
                          cursor: isFormComplete() ? 'pointer' : 'not-allowed'
                        }}
                        onClick={async () => {
                          console.log('🎯 Confirm Appointment button clicked!')
                          console.log('📋 Form validation check:', {
                            isFormComplete: isFormComplete(),
                            termsAgreedTo,
                            isFlexiOrPriorityConsult: isFlexiOrPriorityConsult()
                          })

                          if (!isFormComplete()) {
                            console.log('❌ Form is not complete')
                            return
                          }
                          if (!termsAgreedTo) {
                            console.log('❌ Terms not agreed to')
                            return message.error('Please agree to the terms and conditions')
                          }

                          try {
                            // Skip availability verification for flexi/priority consultations since they don't have assigned doctors or specific times
                            if (!isFlexiOrPriorityConsult()) {
                              console.log('🔍 Verifying availability...')
                              await handleVerifyAvailability(bookingDetails, setVerifying)
                              console.log('✅ Availability verified')
                            } else {
                              console.log('⏭️ Skipping availability check for flexi/priority consult')
                            }

                            console.log('📝 Submitting form...')
                            clientForm.submit()
                          } catch (e) {
                            console.error('❌ Error in button click handler:', e)
                            message.error(handleError(e))
                          }
                        }}
                      />
                    </div>
                  )}
                </Col>
              </CustomRow>
            </div>
          </Form>
          <MobileNav
            isFinalizeStep={true}
            loading={loading}
            bookingDetails={bookingDetails}
            prevStep={prevStep}
            nextStep={nextStep}
            finalizeForm={clientForm}
            finalizeFormDisabled={!termsAgreedTo}
            isVirtualVisit={isVirtualVisit}
          />
          <style>{`
            .payment-method-card:hover {
              transform: translateY(-2px);
              box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
              border-color: ${token.colorPrimary} !important;
            }

            .payment-method-card .ant-radio-wrapper-checked {
              color: ${token.colorPrimary};
            }

            /* Target the card when its sibling radio is checked */
            .payment-method-card:has(+ .ant-radio-wrapper-checked),
            .ant-radio-wrapper-checked + .payment-method-card,
            .payment-method-card:has(.ant-radio-wrapper-checked) {
              border-color: ${token.colorPrimary} !important;
              background: ${hexToRGBA(token.colorPrimary, 0.08)} !important;
              box-shadow: 0 4px 20px rgba(24, 144, 255, 0.15) !important;
            }

            /* Style for when the radio input is checked */
            input[type='radio']:checked + .payment-method-card,
            .payment-method-card:has(input[type='radio']:checked) {
              border-color: ${token.colorPrimary} !important;
              background: ${hexToRGBA(token.colorPrimary, 0.08)} !important;
              box-shadow: 0 4px 20px rgba(24, 144, 255, 0.15) !important;
            }

            /* Handle the parent container when radio is checked */
            div:has(> .ant-radio-wrapper-checked) .payment-method-card {
              border-color: ${token.colorPrimary} !important;
              background: ${hexToRGBA(token.colorPrimary, 0.08)} !important;
              box-shadow: 0 4px 20px rgba(24, 144, 255, 0.15) !important;
            }
          `}</style>
        </>
      )}
    </>
  )
}

export default BookingFinalize
